
import { computed, defineComponent, reactive, ref, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { useRouter } from 'vue-router'
import { CreateTeamService, TeamInfo, CreateTeamParams } from './create-team.service'
import { BrandConfig, useBrandCustomStore } from '@/services/brand-custom.service'

const NAME_MAX_LENGTH = 30

export default defineComponent({
  emits: ['close', 'created'],
  setup (_, context) {
    const { t, locale } = useI18n()
    const injector = useReflectiveInjector([CreateTeamService])
    const service = injector.get(CreateTeamService)
    const router = useRouter()

    const createTeamFormRef = ref()
    const data = reactive({
      userCheck: false,
    })
    const createTeamForm = reactive<CreateTeamParams>({
      name: '',
      scale: -1
    })

    const allowSubmit = computed(() => {
      if (!data.userCheck) {
        return false
      }

      if (!createTeamForm.name) {
        return false
      }

      if (createTeamForm.name.length > NAME_MAX_LENGTH) {
        return false
      }

      return true
    })

    async function setCurrentTeam (team: TeamInfo) {
      try {
        await service.setCurrentTeam(team)
        router.replace('/dashboard')
      } catch {
        // switchTeam API 异常，不允许切换
      }
    }

    const rules = computed(() => ({
      name: [{
        required: true,
        message: t('teamPage.createTeamNameRequired'),
        trigger: ['blur', 'change']
      }, {
        max: NAME_MAX_LENGTH - 1,
        message: t('teamPage.createTeamNameMax', { n: NAME_MAX_LENGTH }),
        trigger: ['blur', 'change']
      }]
    }))

    return {
      t,
      locale,
      NAME_MAX_LENGTH,
      ...toRefs(data),
      brandConfig: useBrandCustomStore().brandConfig as BrandConfig,
      allowSubmit,
      createTeamForm,
      createTeamFormRef,
      setCurrentTeam,
      createTeam () {
        createTeamFormRef.value?.validate((valid: boolean) => {
          if (valid) {
            service.createTeam(createTeamForm).then(async response => {
              localStorage.removeItem('dontShowWelcome')
              await setCurrentTeam(response.info)
              context.emit('close')
              context.emit('created', {
                name: createTeamForm.name,
                num: createTeamForm.scale
              })
            })
          }
        })
      },
      rules,
    }
  },
})
